<template>
    <div id="app" class="el-col-xs-24 el-col-sm-24 el-col-md-16 el-col-md-offset-4">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {};
        },
        created() {
            let lang = localStorage.getItem('lang');
            if (lang) {
                this.$i18n.locale = lang;
            }
        },
        methods: {},
    }
</script>

<style lang="scss">
    @import "../assets/css/common";
</style>
